import { render, staticRenderFns } from "./foto_subir.vue?vue&type=template&id=11ba73a4&scoped=true&"
import script from "./foto_subir.vue?vue&type=script&lang=js&"
export * from "./foto_subir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba73a4",
  null
  
)

export default component.exports